import { render, staticRenderFns } from "./eleFrom.vue?vue&type=template&id=2f6a104d&scoped=true"
import script from "./eleFrom.vue?vue&type=script&lang=js"
export * from "./eleFrom.vue?vue&type=script&lang=js"
import style0 from "./eleFrom.vue?vue&type=style&index=0&id=2f6a104d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f6a104d",
  null
  
)

export default component.exports